import {
  SAVE_POI_FAILURE,
  SAVE_POI_SUCCESS,
  SAVE_POI_REQUEST,
  FETCH_POIS_REQUEST,
  FETCH_POIS_SUCCESS,
  FETCH_POIS_FAILURE,
  DELETE_POI_REQUEST,
  DELETE_POI_SUCCESS,
  DELETE_POI_FAILURE,
  FETCH_POI_REQUEST,
  FETCH_POI_SUCCESS,
  FETCH_POI_FAILURE,
  FETCH_POI_IMAGE_REQUEST,
  FETCH_POI_IMAGE_SUCCESS,
  FETCH_POI_IMAGE_FAILURE,
  FETCH_POI_COMPLETE_REQUEST,
  FETCH_POI_COMPLETE_SUCCESS,
  FETCH_POI_COMPLETE_FAILURE,
  FETCH_SIMPLE_POI_LIST_PDF_REQUEST,
  FETCH_SIMPLE_POI_LIST_PDF_SUCCESS,
  FETCH_SIMPLE_POI_LIST_PDF_FAILURE,
  FETCH_CUSTOM_POI_LIST_PDF_REQUEST,
  FETCH_CUSTOM_POI_LIST_PDF_SUCCESS,
  FETCH_CUSTOM_POI_LIST_PDF_FAILURE,
  FETCH_POIS_DROPDOWN_REQUEST,
  FETCH_POIS_DROPDOWN_SUCCESS,
  FETCH_POIS_DROPDOWN_FAILURE,
} from '../types';

const INITIAL_STATE = {
  poisDropdown: [],
  pois: [],
  poi: null,
  poiComplete: null,
  poiImageUrl: '',
  loading: false,
  error: null,
  simplepPoiList: null,
  simplepPoiListLoading: false,
  custompPoiList: null,
  custompPoiListLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_POIS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POIS_SUCCESS:
      return {
        ...state,
        loading: false,
        pois: action.payload,
      };

    case FETCH_POIS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        pois: [],
      };
    case FETCH_POIS_DROPDOWN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POIS_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        poisDropdown: action.payload,
      };

    case FETCH_POIS_DROPDOWN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        poisDropdown: [],
      };
    case SAVE_POI_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_POI_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_POI_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case DELETE_POI_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_POI_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_POI_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_POI_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POI_SUCCESS:
      return {
        ...state,
        loading: false,
        poi: action.payload,
      };

    case FETCH_POI_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        poi: null,
      };
    case FETCH_POI_IMAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POI_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        poiImageUrl: action.payload,
      };

    case FETCH_POI_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        poiImageUrl: '',
      };
    case FETCH_POI_COMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POI_COMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        poiComplete: action.payload,
      };

    case FETCH_POI_COMPLETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        poiComplete: null,
      };
    case FETCH_SIMPLE_POI_LIST_PDF_REQUEST:
      return {
        ...state,
        simplepPoiListLoading: true,
        error: null,
      };

    case FETCH_SIMPLE_POI_LIST_PDF_SUCCESS:
      return {
        ...state,
        simplepPoiListLoading: false,
        simplepPoiList: action.payload,
      };

    case FETCH_SIMPLE_POI_LIST_PDF_FAILURE:
      return {
        ...state,
        simplepPoiListLoading: false,
        error: action.payload.error,
        simplepPoiList: null,
      };

    case FETCH_CUSTOM_POI_LIST_PDF_REQUEST:
      return {
        ...state,
        custompPoiListLoading: true,
        error: null,
      };

    case FETCH_CUSTOM_POI_LIST_PDF_SUCCESS:
      return {
        ...state,
        custompPoiListLoading: false,
        custompPoiList: action.payload,
      };

    case FETCH_CUSTOM_POI_LIST_PDF_FAILURE:
      return {
        ...state,
        custompPoiListLoading: false,
        error: action.payload.error,
        custompPoiList: null,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
